import React from 'react';
import DocumentoNoDisponible from './DocumentoNoDisponible';

const CompendioCap7 = () => (
  <DocumentoNoDisponible titulo="Compendio Estadístico 2017 - 2021 · Capítulo 7" />
);

export default CompendioCap7;
